import {
  collection, doc, addDoc, deleteDoc,
  query, where, orderBy, onSnapshot, serverTimestamp,
} from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { db, storage } from './firebase';
import { applyRoleFilter, getOwnershipFields } from './dataFilterHelper';

const COLLECTION = 'pdfs';

// ======== UPLOAD PDF + SALVAR METADADO ========
export const savePdf = async (userId, pdfBlob, meta, profile) => {
  const timestamp = Date.now();
  const fileName = `pdfs/${userId}/${meta.tipo}-${meta.banco || 'comparativo'}-${timestamp}.pdf`;
  const storageRef = ref(storage, fileName);

  await uploadBytes(storageRef, pdfBlob, { contentType: 'application/pdf' });
  const downloadUrl = await getDownloadURL(storageRef);

  const ownership = profile ? getOwnershipFields(profile) : { userId, masterId: userId, gestorId: userId };

  return addDoc(collection(db, COLLECTION), {
    ...ownership,
    clientId: meta.clientId || null,
    clientNome: meta.clientNome || 'Simulação avulsa',
    banco: meta.banco || 'Comparativo',
    bancoCor: meta.bancoCor || '#666',
    valorFinanciado: meta.valorFinanciado || '',
    prazo: meta.prazo || '',
    tipo: meta.tipo || 'banco',
    fileName,
    downloadUrl,
    criadoEm: serverTimestamp(),
  });
};

// ======== LISTAR PDFs (com filtro por role) ========
export const subscribePdfsByRole = (profile, callback) => {
  const baseQuery = query(collection(db, COLLECTION), orderBy('criadoEm', 'desc'));
  const filtered = applyRoleFilter(baseQuery, profile);
  return onSnapshot(filtered, (snap) => {
    callback(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
  });
};

// Versão legada (por userId) — mantida para compatibilidade
export const subscribePdfs = (userId, callback) => {
  const q = query(
    collection(db, COLLECTION),
    where('userId', '==', userId),
    orderBy('criadoEm', 'desc')
  );
  return onSnapshot(q, (snap) => {
    callback(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
  });
};

// ======== EXCLUIR PDF (Storage + Firestore) ========
export const deletePdf = async (pdfDoc) => {
  try {
    if (pdfDoc.fileName) {
      const storageRef = ref(storage, pdfDoc.fileName);
      await deleteObject(storageRef);
    }
  } catch (err) {
    console.warn('Arquivo no Storage já removido ou não encontrado:', err);
  }
  await deleteDoc(doc(db, COLLECTION, pdfDoc.id));
};